import { Box, styled } from '@mui/material';

export const IconWrapper = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	width: 'fit-content',
	'& svg, & img': {
		width: 48,
		height: 48,
	},
}));
